import { BrowserModule } from "@angular/platform-browser";
import { NgModule, Inject } from "@angular/core";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { ToastrModule } from "ngx-toastr";
import { GoogleMapsModule } from '@angular/google-maps';

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSliderModule } from "@angular/material/slider";
import { StoreModule, Store } from "@ngrx/store";
import { HttpClientModule } from "@angular/common/http";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { MobileModule } from "./mobile/mobile.module";
import { DesktopModule } from "./desktop/desktop.module";
// import { DeliveryOptionsModule } from "./mobile/delivery-options/delivery-options.module";
import { orderReducer, returnOrderReducer } from "./store/reducers/order.reducer";
import { loadOrderDataAction, fillReturnOrderAction } from "./store/actions/order.actions";
import { AppFlowService } from "./shared/services/app-flow/app-flow.service";
import { AppFlow } from "./shared/services/app-flow/app-flow.model";
import { CopyHelpers } from "./shared/helpers/copy.helpers";
import { I18nModule } from "./i18n/i18n.module";
import { SharedComponentModule } from "./shared/components/shared-component.module";
import { techSupportReducer } from "./store/reducers/tech-support.reducer";
import { AppFooterComponent } from "./shared/components/footer/footer.component";

@NgModule({
  declarations: [AppComponent, AppFooterComponent],
  imports: [
    GoogleMapsModule,
    BrowserModule,
    HttpClientModule,
    MatSliderModule,
    BrowserAnimationsModule,
    MobileModule,
    DesktopModule,
    AppRoutingModule,
    // DeliveryOptionsModule,
    StoreModule.forRoot({
      orderData: orderReducer,
      returnOrder: returnOrderReducer,
      techSupport: techSupportReducer,
    }),
    StoreDevtoolsModule.instrument(),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: "toast-bottom-right",
      preventDuplicates: true,
    }),
    I18nModule,
    SharedComponentModule,
  ],
  providers: [{ provide: "OrderData", useValue: (<any>window).orderData }],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private store: Store<AppState>, @Inject("OrderData") orderData, private appFlowService: AppFlowService) {
    const orderState = this.validateOrderData(this.appFlowService.getActiveAppFlow(), orderData);
    if (orderState.isValid) {
      this.store.dispatch(loadOrderDataAction({ payload: { ...orderData, isValid: true } }));

      // this is considering we are supporting only single order right now
      // remove this ASAP
      const order = CopyHelpers.deepCopy(orderData);
      if (order.orders && order.orders.length) {
        this.store.dispatch(
          fillReturnOrderAction({
            payload: { order: order.orders[0] },
          })
        );
      }
    } else {
      this.store.dispatch(
        loadOrderDataAction({
          payload: {
            isValid: false,
            errorMessage: orderState.errorMessage,
          },
        })
      );
    }
  }

  validateOrderData(appFlow: AppFlow, orderData: any): any {
    /// Check if orderdata is valid
    if (orderData.orders && orderData.orders.length) {
      // check for returnable orders
      if (
        orderData.orders.filter((order) => {
          return Boolean(
            order.orderLines.filter((line) => {
              return line.returnable === "true" || line.returnable === true;
            }).length
          );
        }).length
      ) {
        return {
          isValid: true,
        };
      } else if (appFlow.name !== "formPostNoOrderB2C") {
        // No orders contains retainable orderline
        return {
          isValid: false,
          errorMessage: "noReturnableItems",
        };
      }
    } else {
      return {
        isValid: false,
        errorMessage: "missingCriticalInfo",
      };
    }

    return {
      isValid: true,
    };
  }
}
